module.exports = __webpack_public_path__ + "static/img/customize.85682f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/customize.png
// module id = ghRU
// module chunks = 1